import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingPerformedUpdateAction from './trainingPerformedUpdate.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../trainingPerformedObject'
import { dateOrIsoString } from '~/prix/types/date'

const trainingPerformedUpdateDefinition = defineAction({
  ...trainingPerformedUpdateAction,

  input: z.object({
    id: trainingPerformedObject.shape.id,
    trainingId: z.string().uuid().optional(),
    startDate: trainingPerformedObject.shape.startDate,
    endDate: trainingPerformedObject.shape.endDate,
    location: trainingPerformedObject.shape.location,
    latitude: trainingPerformedObject.shape.latitude,
    longitude: trainingPerformedObject.shape.longitude,
    fullAddress: trainingPerformedObject.shape.fullAddress,
    trainer: trainingPerformedObject.shape.trainer,
    participants: trainingPerformedObject.shape.participants,
    hours: trainingPerformedObject.shape.hours,
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default trainingPerformedUpdateDefinition
